import { Spacer } from "Components/Common/Spacer/index";
import {
  TypographyT53,
  TypographyT54,
  TypographyT63,
} from "Components/Common/Typography/index";
import {
  FlexWrapperT10,
  FlexWrapperT2,
} from "Components/Common/Wrapper/FlexWrapper";
import Cx from 'classnames';
import React, { Component , Fragment}  from "react";
import Moment from "moment";
import { SingleDatePicker } from 'react-dates';

class AdditionalFilesDetailsCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      skuDetails: [],
      invoiceDetails: [],
      stoDetails: [],
      cfsDetails:{},
      isSkuOpen: true,
      isInvoiceOpen:true,
      isStoOpen:true,
      isCfsOpen:true,
    };
  }

  componentDidMount() {
    const { data } = this.props;
    if (data && data.exim_cargo_details) {
      this.setState({
        skuDetails: data.exim_cargo_details.sku_details || [],
        invoiceDetails: data.exim_cargo_details.invoice_details || [],
        stoDetails: data.exim_cargo_details.sto_details || [],
        cfsDetails:data.cfs_docs||{}
      });
    }
  }

  handleToggle1 = () => {
    this.setState((prevState) => ({ isSkuOpen: !prevState.isSkuOpen }));
  };
  handleToggle2 = () => {
    this.setState((prevState) => ({ isInvoiceOpen: !prevState.isInvoiceOpen }));
  };
  handleToggle3 = () => {
    this.setState((prevState) => ({ isStoOpen: !prevState.isStoOpen }));
  };
  
  handleInputChange = (index, field, value) => {
    if(field=="strength"){
    const updatedDetails = [...this.state.skuDetails];
    updatedDetails[index][field] = parseFloat(value);
    this.setState({ skuDetails: updatedDetails });
    }else{
      const updatedDetails = [...this.state.skuDetails];
      updatedDetails[index][field] = value;
      this.setState({ skuDetails: updatedDetails });
    }
  };
  handleInputChange1 = (index, field, value) => {
    if(["invoice_rate","invoice_value"].includes(field)){
      const updatedDetails = [...this.state.invoiceDetails];
      updatedDetails[index][field] = parseFloat(value);
      this.setState({ skuDetails: updatedDetails });
    }else{
      const updatedDetails = [...this.state.invoiceDetails];
      updatedDetails[index][field] = value;
      this.setState({ skuDetails: updatedDetails });
    }
  };
  skuCasesColumnNotSelectable=(item)=>{
  const { data } = this.props;
    if((data.exim_cargo_details || {}).category && (data.exim_cargo_details || {}).category=='BIO'){
      if(item.id){
        return false
      }
    }
    return true; 
  }
  skuStrengthColumnNotSelectable=()=>{
    //bio and bulk scenario both editable
    return false;
  }
  skuBulkQtyColumnNotSelectable=(item)=>{
    const { data } = this.props;
    if((data.exim_cargo_details || {}).category && (data.exim_cargo_details || {}).category=='BULK'){
      if(item.id){
        return false
      }
    }
    return true;
  }
  skuAlcoholicQtyColumnNotSelectable=()=>{
    //bio scenario Not applicable and bulk scenario editable
    const { data } = this.props;
    if((data.exim_cargo_details || {}).category && (data.exim_cargo_details || {}).category=='BIO'){
      return true;
    }
    return false;
  }
  skuTcfColumnNotSelectable=()=>{
    //bio scenario Not applicable and bulk scenario editable
    const { data } = this.props;
    if((data.exim_cargo_details || {}).category && (data.exim_cargo_details || {}).category=='BIO'){
      return true;
    }
    return false;
  }

  handleAddRow = (type) => {
    if(type=='sku'){
      this.setState((prevState) => ({
        skuDetails: [
          ...prevState.skuDetails,
          {
            id: Date.now(), //using this to identify which rows are added manually so can track while deleting
            stock_code: "",
            product_name: "",
            cases_number: "",
            strength: "",
            bulk_quantity: "",
            alcoholic_quantity: "",
            tcf: "",
            created: Date.now().valueOf(),
          },
        ],
      }));
    }
    if(type=='invoice'){
      this.setState((prevState) => ({
        invoiceDetails: [
          ...prevState.invoiceDetails,
          {
            id: Date.now(), //using this to identify which rows are added manually so can track while deleting
            invoice_number: "",
            invoice_date: "",
            invoice_rate: "",
            invoice_value: "",
            created: Date.now().valueOf(),
          },
        ],
      }));
    }
  };

  handleDeleteRow = (id,type) => {
    if(type=='sku'){
      this.setState((prevState) => ({
        skuDetails: prevState.skuDetails.filter((item) => item.id !== id),
      }));
    }
    if(type=='invoice'){
      this.setState((prevState) => ({
        invoiceDetails: prevState.invoiceDetails.filter((item) => item.id !== id),
      }));
    }
  };
  
  render(){
    const { data } = this.props;
    const additionalData = data.additional_data || data.exim_cargo_details || {};
    const { skuDetails, isSkuOpen , invoiceDetails,isInvoiceOpen,stoDetails,isStoOpen,
      cfsDetails, isCfsOpen
    } = this.state;
      return (
      <Fragment>
        <FlexWrapperT10>
          <Wrapper>
            <Fragment>
              <FlexWrapperT2>
                <TypographyT53>Container Number :</TypographyT53>
                <TypographyT54>{additionalData.container_number}</TypographyT54>
              </FlexWrapperT2>
              <Spacer spacing={"2px"} />
              <FlexWrapperT2>
                <TypographyT53>File Name :</TypographyT53>
                <TypographyT54>{additionalData.file_name}</TypographyT54>
              </FlexWrapperT2>
              <Spacer spacing={"2px"} />
              <FlexWrapperT2>
              <TypographyT53>BL No. :</TypographyT53>
              <TypographyT54>{(data.exim_cargo_details || {}).bl_number || '-'}</TypographyT54>
            </FlexWrapperT2>
            <Spacer spacing={"2px"} />
              {/* <FlexWrapperT2>
                <TypographyT53>Invoice Number :</TypographyT53>
                <TypographyT54>{additionalData.invoice_number}</TypographyT54>
              </FlexWrapperT2>
              <Spacer spacing={"2px"} /> */}
              {/* <FlexWrapperT2>
                <TypographyT53>Invoice Date:</TypographyT53>
                <TypographyT54>
                  {additionalData.invoice_date
                    ? Moment(additionalData.invoice_date).format(
                        "DD/MM/YYYY HH:mm:ss"
                      )
                    : "-"}
                </TypographyT54>
              </FlexWrapperT2>
              <Spacer spacing={"2px"} /> */}
              <FlexWrapperT2>
                <TypographyT53>Bill Entry Date:</TypographyT53>
                <TypographyT54>
                  {additionalData.bill_entry_date
                    ? Moment(additionalData.bill_entry_date).format(
                        "DD/MM/YYYY HH:mm:ss"
                      )
                    : "-"}
                </TypographyT54>
              </FlexWrapperT2>
              </Fragment>
          </Wrapper>
          <Wrapper>
            <Fragment>
            <Spacer spacing={"2px"} />
              <FlexWrapperT2>
                <TypographyT53>ETA:</TypographyT53>
                <TypographyT54>
                  {additionalData.eta_date
                    ? Moment(additionalData.eta_date).format(
                        "DD/MM/YYYY HH:mm:ss"
                      )
                    : "-"}
                </TypographyT54>
              </FlexWrapperT2>
              <Spacer spacing={"2px"} />
              <FlexWrapperT2>
                <TypographyT53>ETA Source Plant Date:</TypographyT53>
                <TypographyT54>
                  {additionalData.eta_source_plant_date
                    ? Moment(additionalData.eta_source_plant_date).format(
                        "DD/MM/YYYY HH:mm:ss"
                      )
                    : "-"}
                </TypographyT54>
              </FlexWrapperT2>
              <Spacer spacing={"2px"} />
              <FlexWrapperT2>
                <TypographyT53>ETA Planned Source Port Date:</TypographyT53>
                <TypographyT54>
                  {additionalData.eta_planned_source_port
                    ? Moment(additionalData.eta_planned_source_port).format(
                        "DD/MM/YYYY HH:mm:ss"
                      )
                    : "-"}
                </TypographyT54>
              </FlexWrapperT2>
              {/* <Spacer spacing={"2px"} /> */}
              {/* <FlexWrapperT2>
                <TypographyT53>Product Name :</TypographyT53>
                <TypographyT54>{additionalData.product_name}</TypographyT54>
              </FlexWrapperT2> */}
              {/* <Spacer spacing={"2px"} /> */}
              {/* <FlexWrapperT2>
                <TypographyT53>Stock Code:</TypographyT53>
                <TypographyT54>{additionalData.stock_code}</TypographyT54>
              </FlexWrapperT2> */}
              {/* <Spacer spacing={"2px"} /> */}
              <FlexWrapperT2>
                <TypographyT53>Plant Code :</TypographyT53>
                <TypographyT54>{additionalData.plant_code}</TypographyT54>
              </FlexWrapperT2>
              <Spacer spacing={"2px"} />
              {/* <FlexWrapperT2>
                <TypographyT53>STO/SO Number :</TypographyT53>
                <TypographyT54>{additionalData.sto_number}</TypographyT54>
              </FlexWrapperT2>
              <Spacer spacing={"2px"} /> */}
              {/* <FlexWrapperT2>
                <TypographyT53>STO Date :</TypographyT53>
                <TypographyT54>{additionalData.sto_date ? Moment(additionalData.sto_date).format(
                        "DD/MM/YYYY HH:mm:ss"
                      )
                    : "-"}</TypographyT54>
              </FlexWrapperT2>
              <Spacer spacing={"2px"} /> */}
              {/* <FlexWrapperT2>
                <TypographyT53>Cases Number :</TypographyT53>
                <TypographyT54>{additionalData.cases_number}</TypographyT54>
              </FlexWrapperT2> */}
              {/* <Spacer spacing={"2px"} /> */}
            </Fragment>
          </Wrapper>
          <Wrapper>
          {/* <FlexWrapperT2>
                <TypographyT53>Invoice Rate :</TypographyT53>
                <TypographyT54><span>{additionalData.currency_type || ''}</span>{additionalData.invoice_rate}</TypographyT54>
              </FlexWrapperT2>
              <Spacer spacing={"2px"} /> */}
              {/* <FlexWrapperT2>
                <TypographyT53>Invoice Value :</TypographyT53>
                <TypographyT54><span>{additionalData.currency_type || ''}</span>{additionalData.invoice_value}</TypographyT54>
              </FlexWrapperT2>
              <Spacer spacing={"2px"} /> */}
            <FlexWrapperT2>
              <TypographyT53>Bill Of Entry Number :</TypographyT53>
              <TypographyT54>{additionalData.bill_of_entry_number}</TypographyT54>
            </FlexWrapperT2>
            <Spacer spacing={"2px"} />
            <FlexWrapperT2>
              <TypographyT53>Custom Exchage Rate :</TypographyT53>
              <TypographyT54>{data.exim_cargo_details.custom_exchange_rate}</TypographyT54>
            </FlexWrapperT2>
            <Spacer spacing={"2px"} />
            <FlexWrapperT2>
              <TypographyT53>Duty Paid:</TypographyT53>
              <TypographyT54>{additionalData.duty_paid}</TypographyT54>
            </FlexWrapperT2>
            <Spacer spacing={"2px"} />
            {/* <FlexWrapperT2>
              <TypographyT53>TCF:</TypographyT53>
              <TypographyT54>{additionalData.tcf}</TypographyT54>
            </FlexWrapperT2> */}
            {/* <Spacer spacing={"2px"} /> */}
            {/* <FlexWrapperT2>
              <TypographyT53>Bulk Quantity:</TypographyT53>
              <TypographyT54>{additionalData.bulk_quantity}</TypographyT54>
            </FlexWrapperT2> */}
            {/* <Spacer spacing={"2px"} /> */}
            {/* <FlexWrapperT2>
              <TypographyT53>Alcoholic Quantity:</TypographyT53>
              <TypographyT54>{additionalData.alcoholic_quantity}</TypographyT54>
            </FlexWrapperT2> */}
            {/* <Spacer spacing={"2px"} /> */}
            {/* <FlexWrapperT2>
              <TypographyT53>Strength:</TypographyT53>
              <TypographyT54>{additionalData.strength}<span>{'%'}</span></TypographyT54>
            </FlexWrapperT2> */}
            {/* <Spacer spacing={"2px"} /> */}
            <FlexWrapperT2>
              <TypographyT53>Category:</TypographyT53>
              <TypographyT63>{additionalData.category}</TypographyT63>
            </FlexWrapperT2>
          </Wrapper>
        </FlexWrapperT10>
        <br/>
          {(skuDetails && skuDetails.length > 0)&&
          <div>
            <button 
              // onClick={this.handleToggle1}
              style={{ width: "100%", textAlign: "left", padding: "8px", border: "1px solid #ccc", background: "#627fe9", borderRadius: "4px" ,color:"white", fontWeight:"bold"}}>
              SKU DETAILS
            </button>
            {isSkuOpen && (
              <>
              <table style={{ width: "100%", borderCollapse: "collapse", border: "1px solid #ccc", marginTop: "8px" }}>
                <thead>
                  <tr>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>Stock Code</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px", width:'400px' }}>Product Name</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>Cases Number</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>Strength</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>Bulk Qty</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>Alcoholic Quantity</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>TCF</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>Created Date</th>
                    {!data.exim_cargo_details.sap_message &&
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>Actions</th>
                    } 
                  </tr>
                </thead>
                <tbody>
                  {skuDetails.map((item, index) => (
                    <tr key={index}>
                      <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                        <input
                          type="text"
                          value={item.stock_code}
                          onChange={(e) => this.handleInputChange(index, "stock_code", e.target.value)}
                          style={{ border: "1px solid #ccc", padding: "4px", width: "100%" }}
                        />
                      </td>
                      <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                        <input
                          type="text"
                          value={item.product_name}
                          onChange={(e) => this.handleInputChange(index, "product_name", e.target.value)}
                          style={{ border: "1px solid #ccc", padding: "4px", width: "100%" }}
                        />
                      </td>
                      <td 
                      className={Cx("", {
                      'notSelectableDiv': this.skuCasesColumnNotSelectable(item)
                      })}
                      style={{ border: "1px solid #ccc", padding: "8px" }}
                      >
                        <input
                          type="number"
                          value={item.cases_number}
                          onChange={(e) => this.handleInputChange(index, "cases_number", e.target.value)}
                          style={{ border: "1px solid #ccc", padding: "4px", width: "100%" }}
                          disabled={this.skuCasesColumnNotSelectable(item)}
                        />
                      </td>
                      <td 
                        className={Cx("", {
                          'notSelectableDiv': this.skuStrengthColumnNotSelectable()
                          })}
                        style={{ border: "1px solid #ccc", padding: "8px" }}
                      >
                        <input
                          type="number"
                          value={item.strength}
                          onChange={(e) => this.handleInputChange(index, "strength", e.target.value)}
                          style={{ border: "1px solid #ccc", padding: "4px", width: "100%" }}
                          disabled={this.skuStrengthColumnNotSelectable()}
                        />
                      </td>
                      <td
                        className={Cx("", {
                          'notSelectableDiv': this.skuBulkQtyColumnNotSelectable(item)
                          })}
                        style={{ border: "1px solid #ccc", padding: "8px" }}
                      >
                        <input
                          type="number"
                          value={item.bulk_quantity}
                          onChange={(e) => this.handleInputChange(index, "bulk_quantity", e.target.value)}
                          style={{ border: "1px solid #ccc", padding: "4px", width: "100%" }}
                          disabled={this.skuBulkQtyColumnNotSelectable(item)}
                        />
                      </td>
                      <td
                        className={Cx("", {
                          'notSelectableDiv': this.skuAlcoholicQtyColumnNotSelectable()
                          })}
                        style={{ border: "1px solid #ccc", padding: "8px" }}>
                        <input
                          type="number"
                          value={item.alcoholic_quantity}
                          onChange={(e) => this.handleInputChange(index, "alcoholic_quantity", e.target.value)}
                          style={{ border: "1px solid #ccc", padding: "4px", width: "100%" }}
                          disabled={this.skuAlcoholicQtyColumnNotSelectable()}
                        />
                      </td>
                      <td 
                        className={Cx("", {
                          'notSelectableDiv': this.skuTcfColumnNotSelectable()
                          })}
                        style={{ border: "1px solid #ccc", padding: "8px" }}>
                        <input
                          type="number"
                          value={item.tcf}
                          onChange={(e) => this.handleInputChange(index, "tcf", e.target.value)}
                          style={{ border: "1px solid #ccc", padding: "4px", width: "100%" }}
                          disabled={this.skuTcfColumnNotSelectable()}
                        />
                      </td>
                          <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                          {!!item.created &&
                            Moment(item.created).format("DD/MM/YYYY HH:mm:ss")}
                          </td>
                      {!data.exim_cargo_details.sap_message &&
                          <td style={{ border: "1px solid #ccc", padding: "8px", textAlign: "center" }}>
                        {item.id && (
                          <button
                            style={{
                              padding: "4px 8px",
                              border: "none",
                              background: "#dc3545",
                              color: "white",
                              cursor: "pointer",
                              borderRadius: "3px",
                            }}
                            onClick={() => this.handleDeleteRow(item.id,'sku')}
                          >
                            Delete
                          </button>
                        )}
                      </td>}
                    </tr>
                  ))}
                </tbody>
              </table>
              {!data.exim_cargo_details.sap_message &&
              <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '10px' }}>
                <button
                  style={{ padding: '8px 16px', border: 'none', background: '#28a745', color: 'white', cursor: 'pointer', borderRadius: '3px' }}
                  onClick={()=>this.handleAddRow('sku')}
                >
                  + Add SKU
                </button>
              </div>}
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '2px' }}>
                  <button
                    style={{ padding: '8px 16px', border: 'none', background: '#007BFF', color: 'white', cursor: 'pointer', borderRadius: '3px' }}
                    onClick={()=>{
                      this.props.onSaveAdditionalDetailsSkuDetails(skuDetails, (data.exim_cargo_details || {}).exim_cargo_id)
                    }}
                  > Save </button>
                </div>
              </>
            )}
          </div>}
          <br/>
          {(invoiceDetails && invoiceDetails.length>0)&&
          <div>
            <button 
              // onClick={this.handleToggle2}
              style={{ width: "100%", textAlign: "left", padding: "8px", border: "1px solid #ccc", background: "#627fe9", borderRadius: "4px" ,color:"white", fontWeight:"bold"}}>
              INVOICE DETAILS
            </button>
            {isInvoiceOpen && (
              <>
              <table style={{ width: "100%", borderCollapse: "collapse", border: "1px solid #ccc", marginTop: "8px" }}>
                <thead>
                  <tr>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>Invoice Number</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>Invoice Date</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>Invoice Rate</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>Invoice Value</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>Created Date</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {invoiceDetails.map((item, index) => (
                    <tr key={index}>
                      <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                        <input
                          type="text"
                          value={item.invoice_number}
                          onChange={(e) => this.handleInputChange1(index, "invoice_number", e.target.value)}
                          style={{ border: "1px solid #ccc", padding: "4px", width: "100%" }}
                        />
                      </td>
                      <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                      {/* {!!item.invoice_date &&
                        Moment(item.invoice_date).format("DD/MM/YYYY HH:mm:ss")} */}
                        <SingleDatePicker
                          date={item.invoice_date ? Moment(item.invoice_date) : null}
                          onDateChange={(date) => {
                            const epochValue = date ? date.valueOf() : null;
                            this.handleInputChange1(index, "invoice_date", epochValue);
                          }}
                          focused={this.state.focusedIndex === index}
                          onFocusChange={({ focused }) =>
                            this.setState({ focusedIndex: focused ? index : null })
                          }
                          id={`invoice_date_${index}`}
                          numberOfMonths={1}
                          isOutsideRange={() => false}
                          displayFormat="DD/MM/YYYY"
                        />
                      </td>
                      <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                      {additionalData.currency_type||''}
                      <input
                          type="number"
                          value={item.invoice_rate}
                          onChange={(e) => this.handleInputChange1(index, "invoice_rate", e.target.value)}
                          style={{ border: "1px solid #ccc", padding: "4px", width: "90%", marginLeft:'2px' }}
                        />
                      </td>
                      <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                      {additionalData.currency_type||''}
                      <input
                          type="number"
                          value={item.invoice_value}
                          onChange={(e) => this.handleInputChange1(index, "invoice_value", e.target.value)}
                          style={{ border: "1px solid #ccc", padding: "4px", width: "90%" , marginLeft:'2px' }}
                        />
                      </td>
                      <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                      {!!item.created &&
                        Moment(item.created).format("DD/MM/YYYY HH:mm:ss")}
                      </td>
                      {!data.exim_cargo_details.sap_message &&
                        <td style={{ border: "1px solid #ccc", padding: "8px", textAlign: "center" }}>
                          {item.id && (
                            <button
                                    style={{
                                      padding: "4px 8px",
                                      border: "none",
                                      background: "#dc3545",
                                      color: "white",
                                      cursor: "pointer",
                                      borderRadius: "3px",
                                    }}
                                    onClick={() => this.handleDeleteRow(item.id,'invoice')}
                                  >
                                    Delete
                                  </button>
                                )}
                              </td>}
                    </tr>
                  ))}
                </tbody>
              </table>
              {!data.exim_cargo_details.sap_message &&
              <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '10px' }}>
                <button
                  style={{ padding: '8px 16px', border: 'none', background: '#28a745', color: 'white', cursor: 'pointer', borderRadius: '3px' }}
                  onClick={()=>this.handleAddRow('invoice')}
                >
                  + Add Invoice Detail
                </button>
              </div>}
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '2px' }}>
                  <button
                    style={{ padding: '8px 16px', border: 'none', background: '#007BFF', color: 'white', cursor: 'pointer', borderRadius: '3px' }}
                    onClick={()=>{
                      this.props.onSaveAdditionalDetailsInvoiceDetails(invoiceDetails, (data.exim_cargo_details || {}).exim_cargo_id)
                    }}
                  > Save </button>
                </div>
              </>
            )}
          </div>}
          <br/>
          {(stoDetails && stoDetails.length>0)&&
          <div>
            <button 
              // onClick={this.handleToggle3}
              style={{ width: "100%", textAlign: "left", padding: "8px", border: "1px solid #ccc", background: "#627fe9", borderRadius: "4px" ,color:"white", fontWeight:"bold"}}>
              STO DETAILS
            </button>
            {isStoOpen && (
              <>
              <table style={{ width: "100%", borderCollapse: "collapse", border: "1px solid #ccc", marginTop: "8px" }}>
                <thead>
                  <tr>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>STO Number</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>STO Date</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>Created Date</th>
                  </tr>
                </thead>
                <tbody>
                  {stoDetails.map((item, index) => (
                    <tr key={index}>
                      <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                        {item.sto_number}
                      </td>
                      <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                      {!!item.sto_date &&
                        Moment(item.sto_date).format("DD/MM/YYYY HH:mm:ss")}
                      </td>
                      <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                      {!!item.created &&
                        Moment(item.created).format("DD/MM/YYYY HH:mm:ss")}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              </>
            )}
          </div>}
          <br/>
          {(cfsDetails)&&
          <div>
            <button 
              // onClick={this.handleToggle3}
              style={{ width: "100%", textAlign: "left", padding: "8px", border: "1px solid #ccc", background: "#627fe9", borderRadius: "4px" ,color:"white", fontWeight:"bold"}}>
              CFS DETAILS
            </button>
            {isCfsOpen && (
              <>
              <table style={{ width: "100%", borderCollapse: "collapse", border: "1px solid #ccc", marginTop: "8px" }}>
                <thead>
                  <tr>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>Liner Name</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>Destuff Date</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>Gate In Date</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>Gate Out Date</th>
                  </tr>
                </thead>
                <tbody>
                    <tr>
                      <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                        {cfsDetails.liner_name}
                      </td>
                      <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                      {!!cfsDetails.destuff_date &&
                        Moment(cfsDetails.destuff_date).format("DD/MM/YYYY HH:mm:ss")}
                      </td>
                      <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                      {!!cfsDetails.gateIn_date &&
                        Moment(cfsDetails.gateIn_date).format("DD/MM/YYYY HH:mm:ss")}
                      </td>
                      <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                      {!!cfsDetails.gate_out_date &&
                        Moment(cfsDetails.gate_out_date).format("DD/MM/YYYY HH:mm:ss")}
                      </td>
                    </tr>
                </tbody>
              </table>
              </>
            )}
          </div>}
      </Fragment>
  );
  }
};

export default AdditionalFilesDetailsCard;

import styled from "@emotion/styled";

export const Wrapper = styled.div``;
